// Autogenerated by plugin-surface. Do not edit.

export const derivedSurfaceTreatments = {
  "default": {
    "hover": "defaultHover",
    "focusVisible": "defaultHover",
    "focusWithin": "defaultHover",
    "pressed": "defaultPressed"
  },
  "secondary": {
    "hover": "defaultHover",
    "focusVisible": "defaultHover",
    "focusWithin": "defaultHover",
    "pressed": "defaultPressed"
  },
  "tertiary": {
    "hover": "defaultHover",
    "focusVisible": "defaultHover",
    "focusWithin": "defaultHover",
    "pressed": "defaultPressed"
  },
  "disabled": {},
  "disabledSecondary": {},
  "brand": {
    "hover": "brandHover",
    "focusVisible": "brandHover",
    "focusWithin": "brandHover",
    "pressed": "brandPressed"
  },
  "brandSecondary": {
    "hover": "brandHover",
    "focusVisible": "brandHover",
    "focusWithin": "brandHover",
    "pressed": "brandPressed"
  },
  "brandTertiary": {
    "hover": "brandHover",
    "focusVisible": "brandHover",
    "focusWithin": "brandHover",
    "pressed": "brandPressed"
  },
  "component": {
    "hover": "componentHover",
    "focusVisible": "componentHover",
    "focusWithin": "componentHover",
    "pressed": "componentPressed"
  },
  "componentSecondary": {
    "hover": "componentHover",
    "focusVisible": "componentHover",
    "focusWithin": "componentHover",
    "pressed": "componentPressed"
  },
  "componentTertiary": {
    "hover": "componentHover",
    "focusVisible": "componentHover",
    "focusWithin": "componentHover",
    "pressed": "componentPressed"
  },
  "design": {
    "hover": "designHover",
    "focusVisible": "designHover",
    "focusWithin": "designHover",
    "pressed": "designPressed"
  },
  "designSecondary": {
    "hover": "designHover",
    "focusVisible": "designHover",
    "focusWithin": "designHover",
    "pressed": "designPressed"
  },
  "designTertiary": {
    "hover": "designHover",
    "focusVisible": "designHover",
    "focusWithin": "designHover",
    "pressed": "designPressed"
  },
  "figjam": {
    "hover": "figjamHover",
    "focusVisible": "figjamHover",
    "focusWithin": "figjamHover",
    "pressed": "figjamPressed"
  },
  "figjamSecondary": {
    "hover": "figjamHover",
    "focusVisible": "figjamHover",
    "focusWithin": "figjamHover",
    "pressed": "figjamPressed"
  },
  "figjamTertiary": {
    "hover": "figjamHover",
    "focusVisible": "figjamHover",
    "focusWithin": "figjamHover",
    "pressed": "figjamPressed"
  },
  "selected": {
    "hover": "selectedHover",
    "focusVisible": "selectedHover",
    "focusWithin": "selectedHover",
    "pressed": "selectedPressed"
  },
  "selectedSecondary": {
    "hover": "selectedHover",
    "focusVisible": "selectedHover",
    "focusWithin": "selectedHover",
    "pressed": "selectedPressed"
  },
  "selectedTertiary": {
    "hover": "selectedHover",
    "focusVisible": "selectedHover",
    "focusWithin": "selectedHover",
    "pressed": "selectedPressed"
  },
  "danger": {
    "hover": "dangerHover",
    "focusVisible": "dangerHover",
    "focusWithin": "dangerHover",
    "pressed": "dangerPressed"
  },
  "dangerSecondary": {
    "hover": "dangerHover",
    "focusVisible": "dangerHover",
    "focusWithin": "dangerHover",
    "pressed": "dangerPressed"
  },
  "dangerTertiary": {
    "hover": "dangerHover",
    "focusVisible": "dangerHover",
    "focusWithin": "dangerHover",
    "pressed": "dangerPressed"
  },
  "warning": {
    "hover": "warningHover",
    "focusVisible": "warningHover",
    "focusWithin": "warningHover",
    "pressed": "warningPressed"
  },
  "warningSecondary": {
    "hover": "warningHover",
    "focusVisible": "warningHover",
    "focusWithin": "warningHover",
    "pressed": "warningPressed"
  },
  "warningTertiary": {
    "hover": "warningHover",
    "focusVisible": "warningHover",
    "focusWithin": "warningHover",
    "pressed": "warningPressed"
  },
  "success": {
    "hover": "successHover",
    "focusVisible": "successHover",
    "focusWithin": "successHover",
    "pressed": "successPressed"
  },
  "successSecondary": {
    "hover": "successHover",
    "focusVisible": "successHover",
    "focusWithin": "successHover",
    "pressed": "successPressed"
  },
  "successTertiary": {
    "hover": "successHover",
    "focusVisible": "successHover",
    "focusWithin": "successHover",
    "pressed": "successPressed"
  }
}
